import { render } from "./InsuranceType.vue?vue&type=template&id=9affb534&scoped=true"
import script from "./InsuranceType.vue?vue&type=script&lang=js"
export * from "./InsuranceType.vue?vue&type=script&lang=js"

import "./InsuranceType.vue?vue&type=style&index=0&id=9affb534&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9affb534"]])

export default __exports__